import { graphicPro, graphicFree } from "../drawings"


const SubscriptionGraphics = ( { subscription }) => {
   
   const displayToggle = {
        graphic:       { pro: graphicPro,                    free: graphicFree                  },
        plan:           { pro: "Pro Plan",                   free: "Free Tier"                  },
        API:            { pro: "Unlimited API Usage",        free: "Limited API Usage"          },
        intelligence:   { pro: "20x Usage on Intelligence",  free: "1x Usage on Intelligence"   },  
   }
   
   
    return (
            <div className="subscription-graphics-content-container">

                {/* Main Col 1 of 3 of Parent display: grid - Outer only for now since no inner yet - Left Margin PlaceHolder */}
                <div className="main-column-one"></div>

                {/* Main Col 2 of 3 of Parent display: grid - Outer and Inner style properties Together in Single CSS Class - inner is another display: grid to make what is rendered into this column a grid with two columns (to practice this since we practiced seperating outer and inner into seperate divs / classes in the subscription details section grid) */}
                <div className="main-column-two graphics">

                    {/* Inner grid left cols using "direct children, therefore in flow of grid parent"*/}               
                    <div className="main-col-two-graphics left-col"       >   { subscription.paymentStatus ? displayToggle.graphic.pro       : displayToggle.graphic.free       } </div>
                    <div className="main-col-two-graphics left-col label" >   { subscription.paymentStatus ? displayToggle.plan.pro          : displayToggle.plan.free          } </div>
                    <div className="main-col-two-graphics left-col info"  >   { subscription.paymentStatus ? displayToggle.API.pro           : displayToggle.API.free           } </div>
                    <div className="main-col-two-graphics left-col info"  >   { subscription.paymentStatus ? displayToggle.intelligence.pro  : displayToggle.intelligence.free  } </div>                    

                    {/* Inner grid right cols using "direct children, therefore in flow of grid parent"*/}
                    <div className="main-col-two-graphics right-col">  </div>
                    <div className="main-col-two-graphics right-col">  </div>
                    <div className="main-col-two-graphics right-col">  </div>
                    <div className="main-col-two-graphics right-col">  </div>

                </div>

               {/* Main Col 3 of 3: Outer - Right Margin PlaceHolder */}
               <div className="main-column-three"></div>

            </div>
    )
}

export default SubscriptionGraphics